import { Component, ChangeDetectorRef, DestroyRef, OnInit, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs/operators';
import moment from 'moment/min/moment-with-locales';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ScheduleEvent, ScheduleViewModel } from '../../../shared/models/ScheduleModels';
import { ScheduleService } from '../../../shared/services/schedule.service';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../material/material.module';
import { Globals } from '../../../shared/models/globals';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ScheduleMenuComponent } from "../../components/schedule-menu/schedule-menu.component";
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { GenericEventComponent } from '../../components/generic-event/generic-event.component';
import { GameEventComponent } from '../../components/game-event/game-event.component';

@Component({
  selector: 'app-schedule-week',
  imports: [CommonModule, MatIconModule, MatButtonModule, MatProgressBarModule, GenericEventComponent, GameEventComponent],
  templateUrl: './schedule-week.component.html',
  styleUrl: './schedule-week.component.css'
})
export class ScheduleWeekComponent {

  selectedDate: Date;
  Days: Array<Date> = [];
  isLoading: boolean = false;
  schedule: ScheduleViewModel | null = null;
  //selectedDate = moment();

  public _router =  inject(Router);
  public _globals =  inject(Globals);
  public translate =  inject(TranslateService);
  public _snackBar= inject(MatSnackBar) ;  
  private scheduleService = inject(ScheduleService);
  private route = inject(ActivatedRoute);
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);
    
    constructor() {
      moment.locale(this._globals.selectedLocale);
    }
    
    ngOnInit() {
      this.route.queryParams
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(params => {
          // Access query params here
          const selectedDate = params['selectedDate'];
          // console.log('Week view - query params changed, selectedDate:', selectedDate);
           
          if (selectedDate) {
            this.selectedDate = new Date(selectedDate);
          } else {
            // No selectedDate provided, use today
            // console.log('Week view - no selectedDate param, using today');
            this.selectedDate = new Date();
          }
          this.getScheduleData();
        });
    }

    getEvents(day: Date): Array<ScheduleEvent> {
        /* console.log(this.schedule.EventList.filter( event=>{
          return moment(event.EventStart).isSame(moment(day), 'day');
        })); */

        if (!this.schedule || !this.schedule.EventList) {
          return [];
        }

        return this.schedule.EventList.filter(event => {
          if (event.EventStartUTC.toString().indexOf('Z') === -1) {
            return moment(event.EventStartUTC + 'Z').isSame(moment(day), 'day');
          } else {
            return moment(event.EventStartUTC).isSame(moment(day), 'day');
          }

        });
    }

  addEvent(day: Date) {
    //console.log("addEvent called for day: " + day);
    this._router.navigate(['/schedule/add-event'], { queryParams: { selectedDate: day.toISOString() } });
  }

  deleteEventFromCalendar(eventId: string) {
    this.scheduleService.removeEventFromSchedule(eventId).subscribe(() => {
      this.getScheduleData();
    });
  }

      getScheduleData() {
          if (this.isLoading) {
            // console.log('Week view - already loading, skipping duplicate call');
            return;
          }
          
          this.isLoading = true;
          // console.log('Week view - starting to load data for:', this.selectedDate);
          var theDate = moment(this.selectedDate);

          //console.log(this.currentYear + '-' + (this.currentMonth+1));
          this.scheduleService.getScheduleWeek(theDate.year(), theDate.month()+1, theDate.date())
            .pipe(
              finalize(() => {
                // console.log('Week view - finalize, setting isLoading to false');
                this.isLoading = false;
                this.cdr.detectChanges();
              })
            )
            .subscribe({
            next: (data) => {
              this.schedule = data;
              //console.log(data);
              let a = moment(data.StartDateForWeek);
              let b = a.clone().add(6, 'days');
              let tempDate = a;
              let daysCount = b.diff(a, 'days');
              this.Days = [];
              //this.DayClass = [];
  
            //console.log('*dayscount' + daysCount);
              for (let i = 0; i <= 6; i++) {
  
                  this.Days.push(tempDate.toDate());
  
/*                   var tmpClass = "calendar-day ";
                  if (tempDate < moment(data.StartDateForMonth) || tempDate > moment(data.EndDateForMonth)) {
                      tmpClass += " calendar-day-outofrange ";
                  }
                  if (tempDate.isSame(moment().toDate())) {
                      tmpClass += " calendar-day-today ";
                  } */
                  //console.log(tempDate);
                  //console.log(moment().toDate());
  
      /*             this.DayClass.push(tmpClass); */
  
  
                  tempDate = tempDate.add(1, 'day');  
  
              }
              // console.log('Week view - data loaded successfully, Days:', this.Days.length);
              this.cdr.detectChanges();
              //console.log(this.Days);
            },
            error: (err) => {
              // console.error('Error loading week schedule:', err);
            }
          });
    }
}
